
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return require("private-next-pages/search/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search"])
      });
    }
  